// const SparkLine = ({ data = [], type = "gainer" }) => {
//   const values = data?.filter((v) => Number.isFinite(Number(v))).map(Number);

//   if (values.length < 2) return null;

//   const width = 120;
//   const height = 38;

//   const min = Math.min(...values);
//   const max = Math.max(...values);

//   const points = values
//     .map((value, index) => {
//       const x = (index / (values.length - 1)) * width;
//       const y = height - ((value - min) / (max - min || 1)) * height;

//       return `${x},${y}`;
//     })
//     .join(" ");

//   return (
//     <svg className="dash-sparkline" viewBox={`0 0 ${width} ${height}`}>
//       <polyline
//         points={points}
//         fill="none"
//         stroke={type === "gainer" ? "#16a34a" : "#dc2626"}
//         strokeWidth="2.5"
//         strokeLinecap="round"
//         strokeLinejoin="round"
//       />
//     </svg>
//   );
// };
const SparkLine = ({ type }) => {
  return (
    <svg className={`market-trend-svg ${type}`} viewBox="0 0 120 40">
      {type === "gainer" && (
        <path
          d="
      M5 30
      L15 32
      L25 24
      L35 28
      L45 18
      L55 22
      L65 14
      L75 18
      L85 10
      L95 12
      L105 5
      L115 8
    "
          fill="none"
          stroke="#16a34a"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      )}
      {type === "loser" && (
        <path
          d="
      M5 8
      L15 6
      L25 14
      L35 10
      L45 20
      L55 16
      L65 26
      L75 22
      L85 30
      L95 28
      L105 36
      L115 34
    "
          fill="none"
          stroke="#dc2626"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      )}
    </svg>
  );
};
export default SparkLine;
